export const environment = {
    production: true,
    apiUrl: "/taqman",
    translationBaseUrl: "./gene-expression/assets/i18n/",
};
